import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';

import { getInnerCircleContent } from '../../content/content.selectors';

import { ContentSection, ContentBlock } from '../components';
import ContentListContainer from '../../content/components/ContentListContainer';

import Button from '../../../ui/button/Button';
import {Localize} from '../../../locale/localization';

class InnerCircleAdminPage extends Component {

  renderHeaderActions() {
    return <NavLink to="/admin/inner-circle/add"><Button icon="#plus">{Localize("inner-circle.add")}</Button></NavLink>;
  }

  render() {
    const { items } = this.props;
    return (
      <ContentSection>
        <ContentBlock
          title={Localize("inner-circle.header")}
          renderActions={this.renderHeaderActions}
        >
          <ContentListContainer contents={items} type="inner-circle" widths={['20%', '40%', '40%']} />
        </ContentBlock>
      </ContentSection>
    );
  }
};

const mapStateToProps = (state) => {
  const items = getInnerCircleContent(state);
  return {
    items,
  };
};

const ConnectedInnerCircleAdminPage = connect(
  mapStateToProps,
  null,
)(InnerCircleAdminPage);

export default ConnectedInnerCircleAdminPage;


// WEBPACK FOOTER //
// ./src/modules/pages/admin/InnerCircleAdminPage.js